import React, { useEffect } from "react";
import styled from 'styled-components';
import Header from "../../components/common/header/Header";
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import {isMobileOnly} from 'react-device-detect';
import { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { reqEsBrandStep3, setEsMyInfoStep4Action, setEsMyApplyProdDelAction } from '../../modules/es/esMyModule';
import { getCateListAction } from '../../modules/common/cateModule';
import { getEsProdFilterInfoAction } from '../../modules/common/prodModule';
import { groupBy, forEach, remove, concat, findIndex, replace, find } from 'lodash';
import MyEsOrderBox from '../../components/es/MyEsOrderBox';
import MyEsPopupStep4 from '../../components/es/MyEsPopupStep4';
import MyEsProdItemList from '../../components/es/MyEsProdItemList';
import PaginationMobile from "../../components/common/PaginationMobile";
import Pagination from "../../components/common/Pagination";
import LoadingOverlay from 'react-loading-overlay';
import TagBtnMy from '../../components/common/button/TagBtnMy';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../../components/common/popup/NormalPopup';
import { setEsApplyProdDelAllAction } from '../../modules/es/esApplyModule';
import { setUserReqProdsListAction } from '../../modules/su/userCartModule';
import $ from 'jquery';
import Footer from "../../components/common/Footer";
import * as CONSTANTS from '../../lib/util/Constants';
import MyEsPopupPDStep4 from '../../components/es/MyEsPopupPDStep4';
import MyEsPopupCartStep4 from '../../components/es/MyEsPopupCartStep4';

const EstimateStepBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 4vw; 
        width: 92vw;
        //padding-top: 60px;   
    `:`
        width: 100%;
        margin: 0 auto;
        padding-top: 80px;
    `};

    .yellow {
        color: #ffc742;
    }

    #siteMoveBtn {
        bottom: ${isMobileOnly? '80px': '110px'};
      }
`;

const EstimateStepHeaderBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 0 32px 0;
         
    `:`
        width: 1176px;
        margin: 0 auto;
        margin-bottom: 30px;
    `};
    position:relative;

    .title-num {
        //width: 100vw;
        height: 50px;
        color: #cccccc;
        font-family: 'Berkshire Swash';
        font-size: 18px;
        line-height: 1.28;
        padding-top: 8px;

        .num-left {
            margin-right: 8px;
            ::after {
                content: '';
                display: inline-block;
                width: 21px;
                height: 4px;
                margin-left: 8px;
                object-fit: contain;
                background: url(/assets/images/icon/arrow_my_title.svg) center center/auto no-repeat;
                vertical-align: 6px;
            }
        }
        .num-right {
            margin-left: 8px;
        }
    }

    .close {
        margin-top: 6px;
        margin-right: -3vw;
        width: 36px;
        height: 36px;
        background: url(/assets/images/icon/btn_delete.png) center center/auto no-repeat;
    }
    
    .title {
        ${isMobileOnly?`
        font-size: 22px;
        line-height: 1.45;
        `:`
        font-size: 24px;
        line-height: 1.5;
        `};
        font-family: NotoSansKR;
        font-weight: bold;
        color: #111111;
    }

    .sub {
        font-size: 12px;
        font-weight: normal;
        font-family: NotoSansKR;
        line-height: 2.17;
        color: #cccccc;
    }

    .view-prod {
        position: absolute;
        right: 6vw;
        top: 83px;
        font-size: 14px;
        color: #333333;
        //border-bottom: solid 1px #fd683a;
         ::after {
            content: '';
            display: inline-block;
            width: 9px;
            height: 20px;
            margin-left: 3px;
            object-fit: contain;
            background: url(/assets/images/icon/arrow_right.svg) center center/auto no-repeat;
            background-size: 8px 12px;
            vertical-align: 6px;
            position: absolute;
        } 
    }
`;

const EstimaateTopCateBlcok = styled.div`
    ${isMobileOnly?`
    width: 100vw;
    margin-left: -4vw;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    `:`
    height: 24px;
    overflow: hidden;
    `};

    position: relative;

    .container {
        ${isMobileOnly?`
        width: max-content;
        padding-bottom: 10px;
        `:`
        display: flex;
        white-space: nowrap;
        top: 0px;
        position: relative;
        width: max-content;
        `};
    }

    .top-cate {
        margin-right: 20px;
        //margin-bottom: 10px;
        float: left;
        height: 24px;
        font-size: 16px;
        cursor: pointer;
        line-height: 1.5;
        text-align: center;
        //color : ${props => props.color || '#cccccc'};
        //font-weight: ${props => props.weight || 'normal'};;
    }
    .top-cate:last-child {
        ${isMobileOnly?`
        margin-right: 4vw;
        `:`
            
        `};
    }

    .top-cate:first-child {
        ${isMobileOnly?`
        margin-left: 4vw;
        `:`
            
        `};
    }
`;

const EstimaateTopCateItemBlcok = styled.div`
        color : ${props => props.color || '#cccccc'};
        font-weight: ${props => props.weight || 'normal'};;
`;

const EstimaateTopCateArrowBlcok = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    background-color: #ffffff;
    padding-left: 15px;
`;

const EstimaateTopCateArrowLeftBlcok = styled.button`
    width: 26px;
    height: 26px;
    float: left;
    //padding: 25px;
    //margin-top: 28px;
    background : url(${props => props.backgroundimage}) center no-repeat;;
`;

const EstimaateTopCateArrowRightBlcok = styled.button`
    width: 26px;
    height: 26px;
    float: left;
    //padding: 25px;
    //margin-top: 28px;
    background : url(${props => props.backgroundimage}) center no-repeat;;
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
`;

const EstimateFilterBlock = styled.div`
    ${isMobileOnly?`
    margin-left: -4vw;
    width: 100vw;   
    margin-top: 8px;
    `:`
    width: 100%;
    margin-top: 18px;
    `};
    
    //overflow: scroll hidden;
    
    position: relative;
    margin-bottom: 10px;

    .rConatiner {
        ${isMobileOnly?`
        width: calc(100vw - 70px);  
        overflow: scroll;
        `:`
        width: calc(100% - 70px);
        overflow: auto;
        `};
        
        position: relative;
    }

    .container {
        ${isMobileOnly?`
        `:`
        display: flex;
        white-space: nowrap;
        `};
        
        width: max-content;
        padding-right: 20px;
        padding-bottom: 10px;
    }

    .rConatiner::-webkit-scrollbar {
        ${isMobileOnly?`
         
        `:`
        height: 4px
        `};
        
      }

    .rConatiner::-webkit-scrollbar-thumb {
        ${isMobileOnly?`
         
        `:`
        border-radius: 2px;
        background-color: #ececec;
        `};
        
      }

    .default {
        height: 24px;
        padding: 3px 12px;
        border-radius: 13px;
        background-color: #f4f4f4;

        font-size: 12px;
        font-weight: normal;
        color: #999999;

        margin-right: 6px;
        //margin-bottom: 10px;
        float: left;
        ${isMobileOnly?`
         
        `:`
        flex: 0 0 auto;
        `};
    }

    .default:last-child {
        //margin-right: 4vw;
    }

    .default:first-child {
        ${isMobileOnly?`
        margin-left: 4vw; 
        `:`

        `};
    }

    .top-cate {
        margin-right: 6px;
        float: left;
    }

    .top-cate:first-child {
        ${isMobileOnly?`
        margin-left: 4vw; 
        `:`

        `};
    }

    .orderbox {
        position: absolute;
        top: 0px;
        right: 0px;
        height: 24px;
        background-color: #ffffff;
        width: auto;
        padding-left: 10px;
        
        ${isMobileOnly?`
        padding-right: 4vw;
        `:`

        `};
    }
`;

const EstimateStepContentsBlock = styled.div`
    padding: 0 0 0 0;
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;

const EstimateStepBottomBlock = styled.div`
    margin: 0 -4vw; 
    width: 100vw;
    //display: block;
    position:fixed;
    bottom:0;
    z-index: 10;
    font-size: 13px;
    line-height: 1.46;
    font-weight: normal;
    //border-top: solid 1px #cccccc;
    padding: 20px 10px 30px;
    display: ${props => props.display || 'none'};
    background-color: #ffffff;
    border-top: solid 1px #999999;

    .list {
        padding: 0 18px 0 16px;
    }
    .title {
        color: #999999;
        //margin: 0 18px 0 16px;
        width: 96px;
        display: inline-block;
    }
    .desc {
        color: #333333;
    }

    .num {
        font-weight: 600;
    }

    .green {
        //margin: 0 18px 0 16px;
        color: #79b88a;
    }

    .pre {
        border-radius: 4px;
        background-color: #ececec;
        text-align: center;
        color: #333333;
        height: 52px;
        width: 18%;
        float: left;
    }

    .next {
        border-radius: 4px;
        background-color: #111111;
        text-align: center;
        color: #ffffff;
        height: 52px;
        width: 79%;
        float: right;

        .num {
            //color: #ffc742;
            font-weight: bold;
        }

        .limit {
            font-size: 14px;
        }
        .num2 {
            font-weight: bold;
        }
    }
`;

const EstimateStepBlankBlock = styled.div`
    padding: 0 0 0 0;
    width: 100%;
    max-width: 1176px;
    height: ${props => props.height};//130px;  103px;
`;

const EstimateAddViewBlock = styled.div`
    text-align: center;
    ${isMobileOnly?`
    margin-top: 40px;
    `:`
    margin-top: 20px;
    `};
`;

const EstimateAddViewBtnBlock = styled.button`
    color: #111;
    font-size: 14px;
    text-decoration: underline;
    display: ${props => props.display};//inline-block;
    border-radius: 4px;
`;

const EstimatePopContainer = styled.div`
    ${isMobileOnly?`
    margin-left: -4vw;
    `:`
    
    `};
`;

const StyleLoader = styled(LoadingOverlay)`
    padding:0px;
    margin : 0px;
    margin-top: 0px;
  .MyLoader_overlay {
    background: rgba(0, 0, 0, 0.1);
  }
  &.MyLoader_wrapper--active {
    overflow: hidden;
  }
`;

const EstimatePriceBlock = styled.div`
    margin-left: -4vw;
    width: 100vw;
    //display: block;
    position:fixed;
    bottom:112px;
    z-index: 10;

    opacity: 0.9;
    color: #ffffff;
    font-size: 12px;
    font-weight: 500;
    display: ${props => props.display || 'none'};
    text-align: center;

    .container {
        border-radius: 19px;
        background-color: #323232;
        margin: 0 auto;
        width: 88vw;
        min-height: 38px;
        padding: 4px 0;
    }

    .num {
        font-size: 14px;
    }

    .total {
        margin-left: 16px;
    }
    .green {
        color : #79b88a;
    }

    .yellow {
        color: #ffe7ad;
    }

    .estimate_img {

        ::before {
            content: '';
            display: inline-block;
            width: 21px;
            height: 26px;
            margin-left: 8px;
            object-fit: contain;
            background: url(/assets/images/icon/my_estimate.svg) center center/auto no-repeat;
            vertical-align: -6px;
        }
    }
`;

const EstimatePopBgContainer = styled.div`
    ${isMobileOnly?`
    margin-left: -4vw;
    `:`

    `};
    position: fixed;
    background-color: rgba(0, 0, 0, 0.4);
    width: 100vw;
    height: 100vh;
    z-index: 50;
    
    display: none;
    bottom: 0;
`;

const EstimateStepContentsPCBlock = styled.div`
    width: 1176px;
    margin: 0 auto;
    margin-top: 80px;
    position: relative;
    min-height: 707px;

    .left_con {
        width: 720px;
        //height: 707px;
        float: left;
        position: relative;
        padding: 40px 40px 40px 40px;
        border-radius: 10px;
        border: solid 1px #666666;
        margin-left: 40px;
        ::after {
            content: '';
            display: inline-block;
            width: 48px;
            height: 50px;
            background: url(/assets/images/icon/clip.png) center center/auto no-repeat;
            position: absolute;
            background-size: 48px 50px;
            top: -27px;
            right: 33px;
        }
    }

    .right_con {
        width: 355px;
        float: left;
        margin-left: 20px;
        position: relative;
        height: 707px;

        .step_container {
            max-height: 360px;
            -webkit-overflow-scrolling: touch;
            overflow: auto;
            
        }
        .title {
            font-size: 18px;
            font-weight: 500;
            line-height: 2;
            color: #333333;
            margin-bottom: 15px;
            line-height: 1.2;
        }

        .step {
            font-size: 20px;
            font-weight: 500;
            color: #111111;
            line-height: 1.2;

            .five {
                font-weight: normal;
                color: #999999;
            }
        }

        .line {
            width: 100%;
            height: 1px;
            background-color: #cccccc;
        }

        .sub_title {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color: #999999;
            padding-left: 20px;
        }

        .sub_content {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color: #333333;
            margin-top: 8px;
            padding: 0 20px;
        }

        .bottom {
            position: absolute;
            bottom: 0;
            width: 100%;
        }
        .next {
            border-radius: 4px;
            background-color: #111111;
            text-align: center;
            color: #ffffff;
            height: 52px;
            width: 100%;
            
            .num {
                font-weight: bold;
            }

            .limit {
                font-size: 14px;
            }
            
        }
        .pre {
            border-radius: 4px;
            //background-color: #ececec;
            text-align: center;
            color: #333333;
            height: 52px;
            width: 100%;
            float: left;
            border: solid 1px #cccccc;
            background-color: #ffffff;
        }

        .line_dot {
            width: 100%;
            height: 1px;
            border-bottom: dotted 1px #cccccc;
        }

        .total {
            float: left;
            padding-left: 20px;
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color: #333333;
            ::after {
                content: '';
                display: inline-block;
                width: 21px;
                height: 26px;
                margin-left: 8px;
                object-fit: contain;
                background: url(/assets/images/icon/my_estimate.svg) center center/auto no-repeat;
                vertical-align: -6px;
            }
        }

        .total_price {
            font-size: 20px;
            font-weight: 600;
            text-align: right;
            color: #fc1c67;

            .won {
                font-size: 18px;
                font-weight: normal;
                color: #111111;
            }
        }
        
    }
`;

const ProdBlock = styled.div`
    padding: 0 20px;
    .container-left {
        float: left;
    }
    .container-right {
        float: right;
        width: calc(100% - 70px);
        //padding-top: 15px;
    }

    .prod-name {
        ${isMobileOnly?`
        font-size: 14px;
        font-weight: 400;
        line-height: 1.2;
        color: #333333;
        margin-bottom: 4px;
        padding: 8px 0;
        `:`
        font-size: 14px;
        font-weight: 400;
        line-height: 1.4;
        height: 25px;
        overflow: hidden;
        color: #333333;
        margin-bottom: 4px;
        padding: 8px 0;
        width: calc(100% - 60px);
        `};
    }

    .prod-opt {
        ${isMobileOnly?`
        line-height: 1.33;
        font-size: 12px;
        color: #666666;
        `:`
        line-height: 1.33;
        font-size: 12px;
        color: #666666;
        `};
    }

    .delete {
        font-size: 14px;
        line-height: 1.57;
        color: #111111;
        top: 8px;
        position: relative;
        width: 36px;
        height: 36px;
        background: url(/assets/images/icon/btn_delete.png) center center / auto no-repeat;
    }
    
    
`;

const ProdThumBlock = styled.div`
    ${isMobileOnly?`
    width: 90px;
    height: 90px;
    border-radius: 45px;
    margin-right: 10px;
    background-size: 90px 90px;
    `:`
    width: 55px;
    height: 55px;
    border-radius: 5px;
    margin-right: 10px;
    background-size: 55px 55px;
    `};
    
    background-image : url(${props => props.backgroundimage});
    background-position: center;
`;

const Options = [
    { value: 1, label: "인기순" },
    { value: 2, label: "최신순" },
    { value: 3, label: "낮은가격순" },
    { value: 4, label: "높은가격순" }
];

const MIN_CNT = CONSTANTS.MIN_ITEM;
const CATE_HEIGHT = 24;
const CATE_SLIDE_WIDTH = 480;

const EstimateStep4 = () => {

    const dispatch = useDispatch();
    const refContainer = useRef(null);
    const history = useHistory();
    const [cateItems, setCateItems] = useState([]); //id + name + on
    const [scrollPostion, setScrollPostion] = useState({ heignt: 0, isClick: false });
    const [selBrand, setSelBrand] = useState([]);
    const [popup, setPopup] = useState(false); // 브랜드 팝업
    const [popupPd, setPopupPd] = useState(false); //상세 팝업
    const [popupCart, setPopupCart] = useState(false); //상세 팝업
    const [selCateId, setSelCateId] = useState(-1);
    const [isDefault, setIsDefault] = useState(true);
    const refOrder = useRef(null);
    const [width, setWidth] = useState('300px');
    const [pIndex, setPIndex] = useState(0);
    const [order,setOrder] = useState(1);
    const [curPrice, setCurPrice] = useState([0, 0]);
    const [arrCateId, setArrCateId] = useState([]);
    const [arrFilter, setArrFilter] = useState([]);
    const [checkBrand, setCheckBrand]=useState([]);
    const [curPage, setCurPage]=useState(1);
    const [openModal, setOpenModal] = useState(false);
    const [prodNum, setProdNum] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [isDel, setIsDel] = useState(false);
    const [priceView, setPriceView] = useState(false);

    const refCateContainer = useRef(null);
    const refCateContainer2 = useRef(null);
    const refArrow = useRef(null);
    const [leftArrow, setLeftArrow] = useState(false);
    const [rightArrow, setRightArrow] = useState(true);
    const refRightCon = useRef(null);
    const refLeftCon = useRef(null);
    const refBottom = useRef(null);
    const [fixWing, setFixWing] = useState(true);
    const [pdId, setPdId] = useState("");
    const refRightBottom = useRef(null);

    const { categoryItems, error ,esMyBrandCate1Step, esBrandMyStep1,  esMyBrandCate3Step, esSelBrandStep3, 
        esProdItems, loading, esApplyProdList, esMyBudget, esInfoStep4, esApplyTotalPrice, esBrandFilterInfo} = useSelector(
        ({ cateItemsReducer, esMyReducer, prodItemsReducer, loadingReducer, esApplyReducer }) => ({
            categoryItems: cateItemsReducer.cateItems,
            error: cateItemsReducer.error,
            esMyBrandCate1Step: esMyReducer.esMyBrandCate1Step,
            esBrandMyStep1: esMyReducer.esBrandMyStep1,
            esMyBrandCate3Step: esMyReducer.esMyBrandCate3Step,
            esSelBrandStep3: esMyReducer.esSelBrandStep3,
            esProdItems: prodItemsReducer.esProdItems,
            loading: loadingReducer['prod/REQ_TYPE_ES_PROD_FILTER_INFO'],
            //esApplyProdList: esApplyReducer.esApplyProdList,
            esApplyProdList: esMyReducer.esMyApplyProdList,
            esMyBudget: esMyReducer.esMyBudget,
            esInfoStep4: esMyReducer.esInfoStep4,
            //esApplyTotalPrice: esApplyReducer.esApplyTotalPrice,
            esApplyTotalPrice: esMyReducer.esMyApplyTotalPrice,
            esBrandFilterInfo: prodItemsReducer.esBrandFilterInfo
        })
    );


    // 최소 실행시 Header 관련 처리 추가  
    useEffect(() => {
        dispatch(setCurMenuAction('esapply'));
        dispatch(setHeaderTransferAction(false));
        let tmpList=[];
        dispatch(setUserReqProdsListAction(tmpList));
        if(history.action !== 'POP'){
            let data = [];
            //dispatch(setEsMySelBrandStep3Action(data));
            let store = {}
            dispatch(setEsMyInfoStep4Action(store));
        } 

        if(history.action === 'POP' && esProdItems !== null) {
            if(esInfoStep4 && esInfoStep4.selCateId !== null && esInfoStep4.selCateId !== undefined) {
                //let store = {selCateId:selCateId, arrFilter:arrFilter, arrCateId:arrCateId, curPrice:curPrice,checkBrand:checkBrand,curPage:curPage,order:order}
                setSelCateId(esInfoStep4.selCateId);
                setArrFilter(esInfoStep4.arrFilter);
                setArrCateId(esInfoStep4.arrCateId);
                setCurPrice(esInfoStep4.curPrice);
                setCheckBrand(esInfoStep4.checkBrand);
                setCurPage(esInfoStep4.curPage);
                setOrder(esInfoStep4.order);
                setIsDefault(false);
                //console.log("esInfoStep4 = " + JSON.stringify(esInfoStep4));
            }
        }

        //console.log("esSelBrandStep3 = " + JSON.stringify(esSelBrandStep3));

        if(esSelBrandStep3 && esSelBrandStep3.length < 1) {
            history.goBack();
        }

        if(esMyBudget <= 0) {
            history.goBack();
        }

        document.body.removeAttribute('style');

        //window.addEventListener("scroll", onScroll);
        //return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        var $priceBtn = $('#priceBtn');


        if($priceBtn.length) {
            if($(window).scrollTop() + $(window).height() == $(document).height()) {
                $priceBtn.fadeOut();
                //setPriceView(false)
            } else {
                if(totalPrice>0){
                    $priceBtn.fadeIn();
                }
                
                //setPriceView(true)
            }
        }
        
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, [totalPrice]);

    useEffect(() => {
        if(!isMobileOnly) {
            window.addEventListener("resize", onScroll);
        }
        
        return () => {
            if(!isMobileOnly) {
                window.removeEventListener("resize", onScroll)};
            }
    }, []);

    const onScroll = () => {
        var nowScroll = $(window).scrollTop();
        var $priceBtn = $('#priceBtn');


        if($priceBtn.length) {
            if($(window).scrollTop() + $(window).height() == $(document).height()) {
                $priceBtn.fadeOut();
                //setPriceView(false)
            } else {
                if(totalPrice>0){
                    $priceBtn.fadeIn();
                }
                
                //setPriceView(true)
            }
        }

        if(!isMobileOnly&&refRightCon && refRightCon.current) {

            if (refBottom.current) {
                
                if (document.documentElement.scrollTop < 80 || document.documentElement.scrollTop < refBottom.current.offsetTop - 890) {
                    setFixWing(true);
                    if (refRightCon.current && refLeftCon.current) {
                        const product = refLeftCon.current;
                        const wing = refRightCon.current;
                        var offset = $(product).offset().left;
                        //console.log("offset = " + offset);
                        $(wing).css('left', offset + 720);
    
                    }
                }
                else {
                    setFixWing(false);
                    if (refRightCon.current && refLeftCon.current) {
                        const product = refLeftCon.current;
                        var offset = $(product).offset().left;
                        //console.log("offset22 = " + offset);

                        const wing = refRightCon.current;
                        $(wing).css('left', refLeftCon.current.getBoundingClientRect().width + 40);
    
                    }
                }
            }
        }
    };

    useEffect(() => {
        if (refBottom.current) {
            if (document.documentElement.scrollTop < 80 || document.documentElement.scrollTop < (refBottom.current.offsetTop - 890)) {
                setFixWing(true);
                if (refRightCon.current && refLeftCon.current) {
                    const product = refLeftCon.current;
                    const wing = refRightCon.current;
                    var offset = $(product).offset().left;
                    //console.log("offset = " + offset);
                    $(wing).css('left', offset + 720);

                }
            }
            else {
                setFixWing(false);
                if (refRightCon.current && refLeftCon.current) {
                    const product = refLeftCon.current;
                    var offset = $(product).offset().left;
                    //console.log("offset22 = " + offset);

                    const wing = refRightCon.current;
                    $(wing).css('left', refLeftCon.current.getBoundingClientRect().width + 40);

                }
            }
        }

    }, [refRightCon.current, refLeftCon.current, refBottom.current]);
    
    useEffect(() => {
        if(!isMobileOnly&&refRightBottom&&refRightBottom.current) {
            /* setTimeout(() => {
                //refRightBottom.current.scrollIntoView({ behavior: 'smooth' });
            }, 500); */
        }
    }, [refRightBottom]);
    //#2611 top 버튼 처리
    useEffect(() => {
        const onScroll = () => {
            var nowScroll = $(window).scrollTop();

            /* console.log("scroll = " + nowScroll)
            console.log("height = " + $(window).height())
            console.log("doc = " + $(document).height()) */
            //var $moveBtn = $('#siteMoveBtn');
            /* var $priceBtn = $('#priceBtn');

            if($priceBtn.length) {
                if($(window).scrollTop() + $(window).height() == $(document).height()) {
                    //$priceBtn.fadeOut();
                    setPriceView(false)
                } else {
                    //$priceBtn.fadeIn();
                    setPriceView(true)
                }
            } */
            

            /* if($moveBtn.length){
                if ( nowScroll < 350 ) {
                    $moveBtn.fadeOut();
                } else {
                    $moveBtn.fadeIn();
                }
            } */

        };

        /* var $moveBtn = $('#siteMoveBtn');
        if($moveBtn.length){
            $moveBtn.fadeOut();
        } */

        // scroll 이벤트를 만들어줍니다. 스크롤을 움직일때 마다
        // onScroll 함수가 실행됩니다.
        //window.addEventListener("scroll", onScroll);
        //return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {

        if (categoryItems === null) {
            dispatch(getCateListAction());
        } else {
            let arr = [];
            let first = false;
            forEach(categoryItems, (curobj, index) => {
                let cate1Id = curobj.id;
                forEach(curobj.cate2, (cate2, index) => {
                    let cateid = cate1Id*100 + cate2.id*1;
                    let cateItem = {id:cateid, name:cate2.cate_name, on:false};
                    arr.push(cateItem);
                });
            });
            
            if(esMyBrandCate3Step && esMyBrandCate3Step.length > 0) {
                forEach(arr, (cate, index) => {
                    let idx = findIndex(esMyBrandCate3Step, (curitem) => {
                        //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                        return curitem*1 === cate.id*1;
                    })
    
                    if(idx >= 0) {
                        cate.on = true;

                        if(first === false && selCateId < 0 && (history.action !== 'POP' || esProdItems === null)) {
                            setSelCateId(0);
                            first = true;
                             //cate_id_list, filter, cate3Ids, minprice, maxprice, brandIds, curpage, sort
                            let brandId = [];
                            /* if(checkBrand && checkBrand.length > 0) {
                                forEach(checkBrand, (curobj, index) => {
                                    brandId.push(curobj.brnd_id);
                                });
                            } else */ {
                                forEach(esSelBrandStep3, (curobj, index) => {
                                    brandId.push(curobj.brnd_id);
                                });
                            }
                            //console.log("brandId = "+JSON.stringify(brandId))
                            dispatch(getEsProdFilterInfoAction(esMyBrandCate3Step,[],[],-1,-1,brandId,1,order, isMobileOnly));
                            let init = [];
                            setCurPrice([0, 0]);
                            setArrCateId(init);
                            setArrFilter(init);

                        }
                    } else {
                        cate.on = false;
                    }
                });
    
                //console.log("arr22 = " + JSON.stringify(arr));
                setCateItems(arr);
    
                if(esMyBrandCate3Step ) {
                    dispatch(reqEsBrandStep3(esMyBrandCate3Step, 0));
                }
            } 
            if(!isMobileOnly&&refRightBottom&&refRightBottom.current) {
                setTimeout(() => {
                    if(refRightBottom&&refRightBottom.current) {
                        refRightBottom.current.scrollIntoView({ behavior: 'smooth' });
                    }
                    
                }, 300);
            }
        }

    }, [categoryItems]);

    useEffect(() => {
        if(esBrandMyStep1 === null) {
            history.replace('/estimate/step1');
        }
    }, [esBrandMyStep1]);

    useEffect(() => {
        //console.log("selCateId = "+selCateId)
        if(selCateId*1 > 0) {
            //cate_id_list, filter, cate3Ids, minprice, maxprice, brandIds, curpage, sort
            /* let brandId = [];
             if(checkBrand && checkBrand.length > 0) {
                forEach(checkBrand, (curobj, index) => {
                    brandId.push(curobj.brnd_id);
                });
            } else  {
                forEach(esSelBrandStep3, (curobj, index) => {
                    brandId.push(curobj.brnd_id);
                });
            } */
            //console.log("brandId = "+JSON.stringify(brandId))
            /* dispatch(getEsProdFilterInfoAction(selCateId,[],[],-1,-1,brandId,1,order, isMobileOnly));
            let init = [];
            setCurPrice([0, 0]);
            setArrCateId(init);
            setArrFilter(init);
            setIsDefault(true); */
        }
    }, [selCateId]);

    useEffect(() => {
        if(curPrice[1] > 0 || arrFilter.length>0 || arrCateId.length>0 || (checkBrand&&checkBrand.length>0&&esSelBrandStep3.length!=checkBrand.length) || isDel === true) {
            let brandId = [];
            if(checkBrand && checkBrand.length > 0) {
                forEach(checkBrand, (curobj, index) => {
                    brandId.push(curobj.brnd_id);
                });
            } else {
                forEach(esSelBrandStep3, (curobj, index) => {
                    brandId.push(curobj.brnd_id);
                });
            }
    
            let cateid = [];
            forEach(arrCateId, (curobj, index) => {
                cateid.push(curobj.id);
            });
            
            //console.log("getEsProdFilterInfoAction 111111 arrFilter = " + arrFilter.length)
            //console.log("getEsProdFilterInfoAction 111111 arrCateId = " + arrCateId.length)
            //console.log("getEsProdFilterInfoAction 111111 checkBrand = " + checkBrand.length)
            if(selCateId*1 === 0) {
                dispatch(getEsProdFilterInfoAction(esMyBrandCate3Step,arrFilter,cateid,curPrice[0],curPrice[1],brandId,curPage,order, isMobileOnly));
            } else {
                dispatch(getEsProdFilterInfoAction(selCateId,arrFilter,cateid,curPrice[0],curPrice[1],brandId,curPage,order, isMobileOnly));
            }

            if(isDel === true) {
                setIsDel(false);
            }
        }
        
    }, [curPrice,arrCateId,arrFilter,checkBrand,curPage, isDel]);

    /* useEffect(() => {
        if(curPrice[1] >= 0) {
            let brandId = [];
            if(checkBrand && checkBrand.length > 0) {
                forEach(checkBrand, (curobj, index) => {
                    brandId.push(curobj.brnd_id);
                });
            } else {
                forEach(esSelBrandStep3, (curobj, index) => {
                    brandId.push(curobj.brnd_id);
                });
            }
    
            let cateid = [];
            forEach(arrCateId, (curobj, index) => {
                cateid.push(curobj.id);
            });
                
            dispatch(getEsProdFilterInfoAction(selCateId,arrFilter,cateid,curPrice[0],curPrice[1],brandId,curPage,order, isMobileOnly));
        }
        
    }, [order]); */

    useEffect(() => {
        
        if(esApplyProdList && esApplyProdList.length > 0) {
            let prdNum = 0;
            let price = 0;
            forEach(esApplyProdList, (curitem) => {
                price += curitem.es_opt_pirce*1*curitem.qty*1;
                prdNum += curitem.qty*1;
            });

            setProdNum(prdNum);
            setTotalPrice(price);
            
            if(!isMobileOnly&&refRightBottom&&refRightBottom.current) {
                setTimeout(() => {
                    refRightBottom.current.scrollIntoView({ behavior: 'smooth' });
                }, 300);
            }
        } else {
            setProdNum(0);
            setTotalPrice(0);
        }
    }, [esApplyProdList, esApplyTotalPrice]);

    useEffect(() => {
        if(!isMobileOnly&&refCateContainer&&refCateContainer.current) {
            let height = refCateContainer.current.getBoundingClientRect().height;

            if(refCateContainer.current.getBoundingClientRect())
            //console.log("rec = " + JSON.stringify(refCateContainer.current.getBoundingClientRect()))
            //console.log("offsetTop = " + JSON.stringify(refCateContainer.current.offsetTop))
            //console.log("height = " + JSON.stringify(refCateContainer.current.offsetHeight))
            //console.log("height = " + JSON.stringify($('#cateContainer').height()))
            //console.log("top = " + JSON.stringify($('#cateContainer').position()))
            //$('#cateContainer').height;

            //refCateContainer.current.style.top = refCateContainer.current.offsetTop - 24 + 'px';
            if(refCateContainer.current.getBoundingClientRect().width > refCateContainer2.current.getBoundingClientRect().width) {
                refArrow.current.style.display = "block";
            } else {
                refArrow.current.style.display = "none";
                refCateContainer.current.style.left = '0px';
            }

            handleArrow(refCateContainer.current.offsetLeft);

            /* if(refCateContainer.current.offsetHeight >= CATE_HEIGHT*2) {
                //console.log("offsetWidth = " + JSON.stringify(refCateContainer.current.offsetWidth))
                refCateContainer.current.style.width = refCateContainer2.current.offsetWidth - 42 + 'px';
                refArrow.current.style.display = "block";
            } else {
                refCateContainer.current.style.width = refCateContainer2.current.offsetWidth;
                refArrow.current.style.display = "none";
            }

            if(refCateContainer.current.offsetTop*-1 >= refCateContainer.current.offsetHeight) {
                let top = refCateContainer.current.offsetTop;
                //console.log("top = " + top)
                if(top < 0) {
                    refCateContainer.current.style.top = top + CATE_HEIGHT + 'px';
                }
                
            }

            handleArrow(refCateContainer.current.offsetTop); */
        }
    }, [cateItems]);

    const handleLeftSlider = () => {
        //console.log("handleLeftSlider")
        if(refCateContainer && refCateContainer.current) {
            let left = refCateContainer.current.offsetLeft;
            //console.log("left = " + left)
            if(left >= 0) {
                refCateContainer.current.style.left = '0px';
                handleArrow(0);
            } else {
                refCateContainer.current.style.left = left + CATE_SLIDE_WIDTH + 'px';
                handleArrow(left + CATE_SLIDE_WIDTH );
            }
  
        }

        /* if(refCateContainer && refCateContainer.current) {
            let top = refCateContainer.current.offsetTop;
            //console.log("top = " + top)
            if(top === 0) {
                handleArrow(0);
            } else {
                refCateContainer.current.style.top = top + CATE_HEIGHT + 'px';
                
                handleArrow(top + CATE_HEIGHT );
            }
        } */
    }
    
    const handleRightSlider = () => {
        //console.log("handleRightSlider")
        if(refCateContainer && refCateContainer.current) {
            let left = refCateContainer.current.offsetLeft;
            //console.log("left = " + left)
            if(left*-1 + CATE_SLIDE_WIDTH >= refCateContainer.current.getBoundingClientRect().width 
            || left*-1 + refCateContainer2.current.getBoundingClientRect().width >= refCateContainer.current.getBoundingClientRect().width) {
                handleArrow(left);
            } else {
                refCateContainer.current.style.left = left - CATE_SLIDE_WIDTH + 'px';
                handleArrow(left - CATE_SLIDE_WIDTH);
            }
 
        }

        /* if(refCateContainer && refCateContainer.current) {
            let top = refCateContainer.current.offsetTop;
            //console.log("top = " + top)
            if(top*-1 + CATE_HEIGHT >= refCateContainer.current.offsetHeight) {
                handleArrow(top);
            } else {
                refCateContainer.current.style.top = top - CATE_HEIGHT + 'px';
                
                handleArrow(top - CATE_HEIGHT);
            }
        } */
    }

    const handleArrow = (top) => {
        if(top === 0) {
            setLeftArrow(false);
            setRightArrow(true);
        } else if(top*-1 + CATE_SLIDE_WIDTH >= refCateContainer.current.getBoundingClientRect().width) {
            setLeftArrow(true);
            setRightArrow(false);
        } else if(top*-1 + refCateContainer2.current.getBoundingClientRect().width >= refCateContainer.current.getBoundingClientRect().width) {
            setLeftArrow(true);
            setRightArrow(false);
        } else {
            setLeftArrow(true);
            setRightArrow(true);
        }

        /* if(top === 0) {
            setLeftArrow(false);
            setRightArrow(true);
        } else if(top*-1 + CATE_HEIGHT === refCateContainer.current.offsetHeight) {
            setLeftArrow(true);
            setRightArrow(false);
        } else {
            setLeftArrow(true);
            setRightArrow(true);
        } */
    }

    //#2611 top 버튼 처리
    const handleTopClick = () => {
        //window.scrollTo({ top: 200, behavior: 'smooth' });
        $('html, body').stop().animate({
            scrollTop: 0
        }, 500, 'swing');
    }

    const handleCateClick = (cateid) => {
        //let value = true;
        //setPopup(value)
        setSelCateId(cateid);
         //cate_id_list, filter, cate3Ids, minprice, maxprice, brandIds, curpage, sort
         let brandId = [];
         /* if(checkBrand && checkBrand.length > 0) {
             forEach(checkBrand, (curobj, index) => {
                 brandId.push(curobj.brnd_id);
             });
         } else */ {
             forEach(esSelBrandStep3, (curobj, index) => {
                 brandId.push(curobj.brnd_id);
             });
         }
         //console.log("brandId = "+JSON.stringify(brandId))
         if(cateid*1 === 0) {
            dispatch(getEsProdFilterInfoAction(esMyBrandCate3Step,[],[],-1,-1,brandId,1,order, isMobileOnly));
         } else {
            dispatch(getEsProdFilterInfoAction(cateid,[],[],-1,-1,brandId,1,order, isMobileOnly));
         }
         
         let init = [];
         setCurPrice([0, 0]);
         setArrCateId(init);
         setArrFilter(init);
         setCheckBrand(init);
         setIsDefault(true);
         let store = {}
        dispatch(setEsMyInfoStep4Action(store));
    }

    const handleOptionClick = (value) => {
        let _index = 2;
        if(value === -100) { //브랜드
            _index=0;
        } else if(value === -10) { //가격
            _index=1;
        } else { //옵션
            _index=2;
        }

        setPIndex(_index);
        let value2 = true;
        setPopup(value2);
        
    }

    const handleOpenPopup = (index) => {
        let _index = index;
        setPIndex(_index);
        let value = true;
        setPopup(value);
        
    }

    const handleClosePopup = () => {
        setPopup(false);
        setPIndex(-1);
    }

    const handleClosePopupPd = () => {
        setPopupPd(false);
    }

    const handleClosePopupCart = () => {
        setPopupCart(false);
    }

    const handleCateDelClick = (cateid) => {
        let value = cateid*1;
        
        if(isNaN(value)) {
            let arr = [];
            Object.assign(arr, arrFilter);
            remove(arr, (obj) => {
                return (obj === cateid);
            });
            setArrFilter(arr);

            if(arr.length === 0 && arrCateId.length === 0) {
                setIsDel(true);
            }
        } else {
            let arr = [];
            Object.assign(arr, arrCateId);
            remove(arr, (obj) => {
                return (obj.id*1 === cateid*1);
            });
            setArrCateId(arr);

            if(arr.length === 0 && arrFilter.length === 0) {
                setIsDel(true);
            }
        }

        
    }

    const handleBrandClick = () => {
        let _index = 0;
        setPIndex(_index);
        let value = true;
        setPopup(value);
    }

    const handleBrandDelClick = (brnd_id) => {
        let arr = [];
        Object.assign(arr, checkBrand);
        remove(arr, (obj) => {
            return (obj.brnd_id*1 === brnd_id*1);
        });
        setCheckBrand(arr);

        if(arr.length === 0) {
            setIsDel(true);
        }
    }

    const handlerChangeOrder = (value, width) => {
        if(refOrder && refOrder.current) {
            //console.log("width = " + JSON.stringify( refOrder.current.getBoundingClientRect()))
            //console.log("value = " + value.value)
            setOrder(value.value);
            setCurPage(1);

            if(curPrice[1] >= 0) {
                let brandId = [];
                if(checkBrand && checkBrand.length > 0) {
                    forEach(checkBrand, (curobj, index) => {
                        brandId.push(curobj.brnd_id);
                    });
                } else {
                    forEach(esSelBrandStep3, (curobj, index) => {
                        brandId.push(curobj.brnd_id);
                    });
                }
        
                let cateid = [];
                forEach(arrCateId, (curobj, index) => {
                    cateid.push(curobj.id);
                });
                    
                if(selCateId*1 === 0) {
                    dispatch(getEsProdFilterInfoAction(esMyBrandCate3Step, arrFilter,cateid,curPrice[0],curPrice[1],brandId,1,value.value, isMobileOnly));
                } else {
                    dispatch(getEsProdFilterInfoAction(selCateId,arrFilter,cateid,curPrice[0],curPrice[1],brandId,1,value.value, isMobileOnly));
                }
            }
        }
    }

    const handlePre = () => {
        //setOpenModal(true);
        history.goBack();
    }

    const handleNext = () => {
        //console.log("handleNext");
        //dispatch(setEsMyBudgetAction(price));
        if(esApplyProdList !== null && esApplyProdList !== undefined) {
            var tmpList = [];

            //console.log("tempCheckInfo = " + JSON.stringify(tempCheckInfo))
            if(esApplyProdList !== null && esApplyProdList.length > 0) {
                let resGrpJson = groupBy(esApplyProdList, (item) => {
                    return item.brnd_id;
                });
    
                forEach(resGrpJson, (value, key) => {
                    let tmpItem = { 'brnd_id': key, 'list': value };
                    /* let idx = findIndex(prodCartInputInfo, (curitem) => {
                        return (curitem.brnd_id*1 === key*1);
                    }) */

                    /* if(idx >= 0) {
                        let value = prodCartInputInfo[idx].inputRef.current.value;
                        //let price = prodCartInputInfo[idx].inputRef.current.value.replace(",","");
                        let price = replace(prodCartInputInfo[idx].inputRef.current.value, /,/g, "");

                        tmpItem.price = 0;//price*1;
                        //console.log('value = ' + value)
                        //console.log('price = ' + price)

                    } */
                    tmpItem.price = 0;
                    tmpList.push(tmpItem);
                })

                //console.log("tmpList = " + JSON.stringify(tmpList))
                let store = {selCateId:selCateId, arrFilter:arrFilter, arrCateId:arrCateId, curPrice:curPrice,checkBrand:checkBrand,curPage:curPage,order:order}
                //selCateId,arrFilter,cateid,curPrice[0],curPrice[1],brandId,curPage,order
                dispatch(setEsMyInfoStep4Action(store));

                dispatch(setUserReqProdsListAction(tmpList));
                history.push("/estimate/step4");
            }
        }
        
        //dispatch(setEsMySelBrandStep3Action(selBrand));
    }

    const handleChangePageNum = (value) => {
        setCurPage(value)
        
            
        if(curPrice[1] === 0) {
            let brandId = [];
            if(checkBrand && checkBrand.length > 0) {
                forEach(checkBrand, (curobj, index) => {
                    brandId.push(curobj.brnd_id);
                });
            } else {
                forEach(esSelBrandStep3, (curobj, index) => {
                    brandId.push(curobj.brnd_id);
                });
            }
    
            let cateid = [];
            forEach(arrCateId, (curobj, index) => {
                cateid.push(curobj.id);
            });

            if(selCateId*1 === 0) {
                dispatch(getEsProdFilterInfoAction(esMyBrandCate3Step,arrFilter,cateid,curPrice[0],curPrice[1],brandId,value,order, isMobileOnly));
            } else {
                dispatch(getEsProdFilterInfoAction(selCateId,arrFilter,cateid,curPrice[0],curPrice[1],brandId,value,order, isMobileOnly));
            }
            
        }
        
        window.scrollTo(0, 0);
    }

    const handleReceiveFromPopup = (curPrice, arrCateId, arrFilter, checkBrand) => {
        setCurPrice(curPrice);
        setArrCateId(arrCateId);
        setArrFilter(arrFilter);
        //setCheckBrand(checkBrand);
        setIsDefault(false);
        setCurPage(1);

        let _checkBrand = [];
        forEach(checkBrand, (curobj, index) => {
            let idx = findIndex(esBrandFilterInfo, (curitem) => {
                return curitem.key*1 === curobj.brnd_id*1;
            })
            if(idx>=0){
                _checkBrand.push(curobj);
            }

            //brandId.push(curobj.brnd_id);
        });

        setCheckBrand(_checkBrand);

        //console.log("checkBrand = " + JSON.stringify(_checkBrand));
        let brandId = [];
        if(checkBrand && checkBrand.length > 0) {
            forEach(checkBrand, (curobj, index) => {
                let idx = findIndex(esBrandFilterInfo, (curitem) => {
                    return curitem.key*1 === curobj.brnd_id*1;
                })
                if(idx>=0){
                    brandId.push(curobj.brnd_id);
                }

                //brandId.push(curobj.brnd_id);
            });
        } else {
            forEach(esSelBrandStep3, (curobj, index) => {
                brandId.push(curobj.brnd_id);
            });
        }

        let cateid = [];
        forEach(arrCateId, (curobj, index) => {
            cateid.push(curobj.id);
        });
        //cate_id_list, filter, cate3Ids, minprice, maxprice, brandIds, curpage, sort
        //dispatch(getEsProdFilterInfoAction(selCateId,arrFilter,cateid,curPrice[0],curPrice[1],brandId,1,order, isMobileOnly));
    }

    const handlePdClick = (id) => {
        if(isMobileOnly) {
            let store = {selCateId:selCateId, arrFilter:arrFilter, arrCateId:arrCateId, curPrice:curPrice,checkBrand:checkBrand,curPage:curPage,order:order}
            //selCateId,arrFilter,cateid,curPrice[0],curPrice[1],brandId,curPage,order
            dispatch(setEsMyInfoStep4Action(store));
    
            history.push('/prod2?prodid=' +id);
        } else {
            setPdId(id);
            setPopupPd(true);
        }
        
    }

    const handleCartClick = () => {
        if(isMobileOnly) {
            setPopupCart(true);
        } 
        
    }

    const handleDeletePd = (item) => {
        dispatch(setEsMyApplyProdDelAction(item));
    }

    const handleModalBtn1Click = () => {
        dispatch(setEsApplyProdDelAllAction());
        setOpenModal(false);
        history.goBack();
    }

    // 닫기
    const handleModalBtn2Click = () => {
        setOpenModal(false);
    }

    const getPopup = () => {
        let msg = "해당 Step에서 입력한 모든 내용이\n초기화 됩니다";
        return (<NormalPopup
            text={""}
            text2={msg}
            text3={""}
            btn1="뒤로가기" btn2="취소"
            onClick1={handleModalBtn1Click}
            onClick2={handleModalBtn2Click} />)

    }

    const getPopupStyle = () => {
        return customModalStyles;
    }

    const getBottomBtnText = () => {
        if(esApplyProdList && esApplyProdList.length === 0) {
            return "개 이상 상품을 요청서에 담아주세요🙂";
        } else if(esApplyProdList && esApplyProdList.length > 0 && prodNum*1 === 1) {
            return "개 더 상품을 요청서에 담아주세요🙂";
        } else if(esApplyProdList && esApplyProdList.length > 0 && prodNum*1 > 1) {
            return "개 요청서 작성하기👉";
        } else {
            return "개 이상 상품을 요청서에 담아주세요🙂";
        }
    }

    const getPrice = () => {
        if(esMyBudget === 0) {
            return "";
        } else {
            return Number(esMyBudget.toFixed(1)).toLocaleString() + "원"
        }

    }

    const getCate2Name = () => {
        let txtCate2 = "";
        cateItems.map((cateitem,index) => {
            const cateid = cateitem.id;
            const name = cateitem.name;
            if(cateitem.on) {
                if(txtCate2.length === 0) {
                    txtCate2 = name + "";
                } else {
                    txtCate2 = txtCate2 + ", "+name;
                }
            }
            
        })
        
        return txtCate2;
    }

    const getBrandName = () => {
        let txtBrand = "";
        esSelBrandStep3.map((brand,index) => {
            const name = brand.brnd_han;
            if(txtBrand.length === 0) {
                txtBrand = name + "";
            } else {
                txtBrand = txtBrand + ", "+name;
            }
        })

        return txtBrand;
    }

    const getPrductNum = () => {
        let txtNum = "";
        if(prodNum>0){
            txtNum=prodNum + "개";
        }

        return txtNum;
    }

    const setEsBoxPosition = (fixWing) => {
        let style = fixWing ? { position: 'fixed', left: '772px',bottom: 'auto'/* , bottom: 'auto', marginTop: '30px' */ } : { position: 'absolute', left: '772px', bottom: '0px'/* , bottom: '100px', marginTop: '30px' */ }
        return isMobileOnly ? { marginTop: '30px' } : style;
    }

    const getFilterOrderValue = () => {
        for (var i = 0; i < Options.length; i++) {
            if (order === Options[i].value) {
                return Options[i];
            }
        }
    }

    return (
        isMobileOnly?
        <EstimateStepBlock>
                {/* <Header /> */}
                <EstimateStepHeaderBlock className="clearfix">
                    <div className="clearfix">
                    <div className="title-num f-left"><span className="num-left">3</span><span>4</span></div>{/* <div className="close f-right"></div> */}
                    </div>
                    <div className="title"><p><span className="yellow">상품</span>을</p><p>담아주세요😉</p></div>
                    <div className="view-prod"style={{display:prodNum>0? "block":'none'}}  onClick={handleCartClick}>상품보기</div>
                    {/* <div className="sub">나만의 가구 견적 알아보기</div> */}

                </EstimateStepHeaderBlock>
                <EstimaateTopCateBlcok>
                    <div className="container clearfix">
                    <EstimaateTopCateItemBlcok key={0} className="top-cate" color={0*1===selCateId*1? '#111111':'#cccccc'} 
                                        weight={0*1===selCateId*1? 'bold':'normal'} onClick={()=>handleCateClick(0)}>전체
                    </EstimaateTopCateItemBlcok>
                    {
                        cateItems.map((cateitem,index) => {
                                const cateid = cateitem.id;
                                const name = cateitem.name;
                                //console.log("cateid = " + cateid + ' selcateid = '+selCateId)
                                if(cateitem.on) {
                                    return (
                                        <EstimaateTopCateItemBlcok key={cateid} className="top-cate" color={cateid*1===selCateId*1? '#111111':'#cccccc'} 
                                        weight={cateid*1===selCateId*1? 'bold':'normal'} onClick={()=>handleCateClick(cateid)}>{name}
                                        </EstimaateTopCateItemBlcok>
                                    );
                                }
                                
                            })
                        }
                    </div>
                </EstimaateTopCateBlcok>
                <EstimateFilterBlock>
                {
                    isDefault?
                    <div className="rConatiner" width={width}>
                    <div className="container clearfix" >
                        <button className="default" onClick={()=>handleOpenPopup(0)}>전체브랜드</button>
                        <button className="default" onClick={()=>handleOpenPopup(1)}>가격</button> 
                        {selCateId*1>0&&<button className="default" onClick={()=>handleOpenPopup(2)}>옵션</button> }
                    </div>
                    </div>
                    :
                    <div className="rConatiner" width={width}>
                    <div className="container clearfix" >
                        {
                            esBrandFilterInfo&&checkBrand.length>0&&esBrandFilterInfo.length!=checkBrand.length&&checkBrand.map((item,index) => {
                                
                                return (<div key={item.brnd_id} className="top-cate">
                                    <TagBtnMy
                                        active={true}
                                        float='left'
                                        onClick={handleBrandClick}
                                        onDelClick={handleBrandDelClick}
                                        text={item.brnd_han} isSmall={true} value={item.brnd_id}
                                    />
                                </div>)
                                
                            })

                            /* checkBrand.length>0&&esSelBrandStep3.length!=checkBrand.length&&<div className="top-cate">
                            <TagBtnMy
                                active={true}
                                float='left'
                                onClick={handleOptionClick}
                                noDelBtn={true}
                                text={'브랜드'} isSmall={true} value={-100}
                            />
                            </div> */
                        }
                        {
                            curPrice[1]>0&&<div className="top-cate">
                            <TagBtnMy
                                active={true}
                                float='left'
                                onClick={handleOptionClick}
                                noDelBtn={true}
                                text={Number(curPrice[0].toFixed(1)).toLocaleString()+'원~'+ Number(curPrice[1].toFixed(1)).toLocaleString()+'원'} isSmall={true} value={-10}
                            />
                            </div>
                        }
                        {
                            arrCateId.length>0&&arrCateId.map((item,index) => {
                                
                                return (<div key={item.id} className="top-cate">
                                    <TagBtnMy
                                        active={true}
                                        float='left'
                                        onClick={handleOptionClick}
                                        onDelClick={handleCateDelClick}
                                        text={item.name} isSmall={true} value={item.id}
                                    />
                                </div>)
                                
                            })
                        }
                        {
                            arrFilter.length>0&&arrFilter.map((item,index) => {
                                
                                return (<div key={item} className="top-cate">
                                    <TagBtnMy
                                        active={true}
                                        float='left'
                                        onClick={handleOptionClick}
                                        onDelClick={handleCateDelClick}
                                        text={item} isSmall={true} value={item}
                                    />
                                </div>)
                                
                            })
                        }
                        {
                            (checkBrand.length===0||esBrandFilterInfo&&esBrandFilterInfo.length===checkBrand.length)&&<button className="default" onClick={()=>handleOpenPopup(0)}>전체브랜드</button>
                        }
                        {
                            curPrice[1]===0&&<button className="default" onClick={()=>handleOpenPopup(1)}>가격</button> 
                        }
                        {
                            selCateId*1>0&&arrCateId.length===0&&arrFilter.length===0&&<button className="default" onClick={()=>handleOpenPopup(2)}>옵션</button> 
                            
                        }
                        
                    </div>
                    </div>
                }
                <div className="product-select orderbox" ref={refOrder}>
                                                <MyEsOrderBox
                                                options={Options}
                                                placeholder=""
                                                onChange={handlerChangeOrder}
                                                height={'24px'} />
                                            </div>
                </EstimateFilterBlock>
                <EstimateStepContentsBlock ref={refContainer}>
                <StyleLoader
                active={loading}
                //active = "true"
                spinner
                text=''
                classNamePrefix='MyLoader_'>
                {
                    /* esBrandMyStep3&&esBrandMyStep3.length>0&&esBrandMyStep3.map((brand,index) => {
                        return (<MyEsBrandItem key={brand.brand.brnd_id} info={brand} selBrand={selBrand} handleSelBrand={handleSelBrand}/>);
                    }) */
                    <MyEsProdItemList prodItems={esProdItems} handleClick={handlePdClick}/>
                }
                {
                    isMobileOnly?
                    <PaginationMobile updatePageNum={handleChangePageNum} prodItems={esProdItems} />
                    :
                    <Pagination updatePageNum={handleChangePageNum} prodItems={esProdItems} />
                }
                </StyleLoader>
                </EstimateStepContentsBlock>
                
                <EstimateStepBlankBlock height={esMyBudget&&esMyBudget>0&&totalPrice>0? "130px":"103px"}>&nbsp;</EstimateStepBlankBlock>
                <EstimatePriceBlock id="priceBtn" display={esMyBudget&&esMyBudget>0&&totalPrice>0&&priceView? "block":"none"}>
                    <div className="container">
                        <span className="estimate_img">예산 : <span className="num">{esMyBudget&&Number(esMyBudget.toFixed(1)).toLocaleString()}</span>원</span>
                        <span className="total">총계 : <span className={(esMyBudget*0.8)<=totalPrice&&(esMyBudget*1.2)>=totalPrice? "num green":"num yellow"}>{totalPrice&&Number(totalPrice.toFixed(1)).toLocaleString()}</span>원</span>
                </div>
                </EstimatePriceBlock>
            <EstimateStepBottomBlock display={esMyBrandCate1Step&&esMyBrandCate1Step.length>0? "block":"none"}>
                {/* <div className="list margin_b-10"><span className="title">총 예상 금액</span><span className="num">{esBrandMyStep1&&esBrandMyStep1.min&&Number(esBrandMyStep1.min.toFixed(1)).toLocaleString()}</span>원 ~ 
                <span className="num"> {esBrandMyStep1&&esBrandMyStep1.max&&Number(esBrandMyStep1.max.toFixed(1)).toLocaleString()}</span><span>원</span></div>
                <div className="list margin_b-20"><div className="green">*품목별 수량이 1개일 경우의 예상 범위 금액입니다.</div></div> */}
                <button className="pre" onClick={handlePre}>이전</button>
                {
                    prodNum<MIN_CNT?
                        <button className="next">
                        <span>{prodNum}</span>개 확인하기<span className="limit"> ({MIN_CNT}개 이상)</span></button>
                    :
                        <button className="next" onClick={esApplyProdList&&esApplyProdList.length>0&&prodNum>1?handleNext:undefined}>
                        선택한 <span className="num">{prodNum}</span>개 상품 목록보기</button>
                }
                
            </EstimateStepBottomBlock>
            <EstimatePopBgContainer style={{display:popup? "block":'none'}}/>
            <EstimatePopContainer>
                <MyEsPopupStep4 active={popup} handleClosePopup={handleClosePopup} pCateId={selCateId} pIndex={pIndex} handleReceiveFromPopup={handleReceiveFromPopup}/>
            </EstimatePopContainer>
            <EstimatePopBgContainer style={{display:popupCart? "block":'none'}}/>
            <EstimatePopContainer>
                <MyEsPopupCartStep4 active={popupCart} handleClosePopup={handleClosePopupCart} esApplyProdList={esApplyProdList} handlePdClick={handlePdClick} handleDeletePd={handleDeletePd} />
            </EstimatePopContainer>
            {/* {isMobileOnly? 
            <div id="siteMoveBtn" style={{display: "none"}}>
                <button type="button" className="top" onClick={handleTopClick}></button>
            </div>
            :
             ""
            } */}
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}
            </Modal>
        </EstimateStepBlock>
        :
        <EstimateStepBlock>
                <Header /> 
                <EstimateStepContentsPCBlock className="clearfix">
                    <div className="left_con clearfix" ref={refLeftCon}>
                        <EstimateStepHeaderBlock className="clearfix">
                            <div className="title"><p><span className="yellow">상품</span>을 담아주세요😉</p></div>
                        </EstimateStepHeaderBlock>
                        <EstimaateTopCateBlcok ref={refCateContainer2}>
                            <div className="container clearfix" ref={refCateContainer} id="cateContainer">
                            <EstimaateTopCateItemBlcok key={0} className="top-cate" color={0===selCateId*1? '#111111':'#cccccc'} 
                                                weight={0*1===selCateId*1? 'bold':'normal'} onClick={()=>handleCateClick(0)}>전체
                            </EstimaateTopCateItemBlcok>
                            {
                                cateItems.map((cateitem,index) => {
                                        const cateid = cateitem.id;
                                        const name = cateitem.name;
                                        //console.log("cateid = " + cateid + ' selcateid = '+selCateId)
                                        if(cateitem.on) {
                                            return (
                                                <EstimaateTopCateItemBlcok key={cateid} className="top-cate" color={cateid*1===selCateId*1? '#111111':'#cccccc'} 
                                                weight={cateid*1===selCateId*1? 'bold':'normal'} onClick={()=>handleCateClick(cateid)}>{name}
                                                </EstimaateTopCateItemBlcok>
                                            );
                                        }
                                        
                                    })
                                }
                            </div>
                            <EstimaateTopCateArrowBlcok className="btn_arrow" ref={refArrow}>
                                <EstimaateTopCateArrowLeftBlcok className="btn_left" backgroundimage={leftArrow?'/assets/images/icon/arrow_left.svg':'/assets/images/icon/arrow_left_dim.svg'} onClick={handleLeftSlider}/>
                                <EstimaateTopCateArrowRightBlcok className="btn_right" backgroundimage={rightArrow?'/assets/images/icon/arrow_left.svg':'/assets/images/icon/arrow_left_dim.svg'} onClick={handleRightSlider}/>
                            </EstimaateTopCateArrowBlcok>
                        </EstimaateTopCateBlcok>
                        <EstimateFilterBlock>
                        {
                            isDefault?
                            <div className="rConatiner" width={width}>
                            <div className="container clearfix" >
                                <button className="default" onClick={()=>handleOpenPopup(0)}>전체브랜드</button>
                                <button className="default" onClick={()=>handleOpenPopup(1)}>가격</button> 
                                {selCateId*1>0&&<button className="default" onClick={()=>handleOpenPopup(2)}>옵션</button> }
                            </div>
                            </div>
                            :
                            <div className="rConatiner" width={width}>
                            <div className="container clearfix" >
                                {
                                    esBrandFilterInfo&&checkBrand.length>0&&esBrandFilterInfo.length!=checkBrand.length&&checkBrand.map((item,index) => {
                                        
                                        return (<div key={item.brnd_id} className="top-cate">
                                            <TagBtnMy
                                                active={true}
                                                float='left'
                                                onClick={handleBrandClick}
                                                onDelClick={handleBrandDelClick}
                                                text={item.brnd_han} isSmall={true} value={item.brnd_id}
                                            />
                                        </div>)
                                        
                                    })
                                }
                                {
                                    curPrice[1]>0&&<div className="top-cate">
                                    <TagBtnMy
                                        active={true}
                                        float='left'
                                        onClick={handleOptionClick}
                                        noDelBtn={true}
                                        text={Number(curPrice[0].toFixed(1)).toLocaleString()+'원~'+ Number(curPrice[1].toFixed(1)).toLocaleString()+'원'} isSmall={true} value={-10}
                                    />
                                    </div>
                                }
                                {
                                    arrCateId.length>0&&arrCateId.map((item,index) => {
                                        
                                        return (<div key={item.id} className="top-cate">
                                            <TagBtnMy
                                                active={true}
                                                float='left'
                                                onClick={handleOptionClick}
                                                onDelClick={handleCateDelClick}
                                                text={item.name} isSmall={true} value={item.id}
                                            />
                                        </div>)
                                        
                                    })
                                }
                                {
                                    arrFilter.length>0&&arrFilter.map((item,index) => {
                                        
                                        return (<div key={item} className="top-cate">
                                            <TagBtnMy
                                                active={true}
                                                float='left'
                                                onClick={handleOptionClick}
                                                onDelClick={handleCateDelClick}
                                                text={item} isSmall={true} value={item}
                                            />
                                        </div>)
                                        
                                    })
                                }
                                {
                                    (checkBrand.length===0||esBrandFilterInfo&&esBrandFilterInfo.length===checkBrand.length)&&<button className="default" onClick={()=>handleOpenPopup(0)}>전체브랜드</button>
                                }
                                {
                                    curPrice[1]===0&&<button className="default" onClick={()=>handleOpenPopup(1)}>가격</button> 
                                }
                                {
                                    selCateId*1>0&&arrCateId.length===0&&arrFilter.length===0&&<button className="default" onClick={()=>handleOpenPopup(2)}>옵션</button> 
                                    
                                }
                                
                            </div>
                            </div>
                        }
                        <div className="product-select orderbox" ref={refOrder}>
                                                        <MyEsOrderBox
                                                        options={Options}
                                                        placeholder=""
                                                        onChange={handlerChangeOrder}
                                                        valueDefault={getFilterOrderValue()}
                                                        height={'24px'} />
                                                    </div>
                        </EstimateFilterBlock>
                        <EstimateStepContentsBlock ref={refContainer}>
                        <StyleLoader
                        active={loading}
                        //active = "true"
                        spinner
                        text=''
                        classNamePrefix='MyLoader_'>
                        {
                            /* esBrandMyStep3&&esBrandMyStep3.length>0&&esBrandMyStep3.map((brand,index) => {
                                return (<MyEsBrandItem key={brand.brand.brnd_id} info={brand} selBrand={selBrand} handleSelBrand={handleSelBrand}/>);
                            }) */
                            <MyEsProdItemList prodItems={esProdItems} handleClick={handlePdClick}/>
                        }
                        {
                            isMobileOnly?
                            <PaginationMobile updatePageNum={handleChangePageNum} prodItems={esProdItems} />
                            :
                            <div className="margin_t-20"><Pagination updatePageNum={handleChangePageNum} prodItems={esProdItems} /></div>
                        }
                        </StyleLoader>
                        </EstimateStepContentsBlock>
                    </div>
                    <div className="right_con clearfix" ref={refRightCon} style={setEsBoxPosition(fixWing)}>
                        <div className="title">나만의 상품 견적 알아보기</div>
                        <div className="step margin_b-40"><span>Step 3 </span><span className="five">/ 4</span></div>
                        <div className="line" />
                        <div className="step_container small_scroll">
                        
                        <div className="sub_title  margin_t-20">1. 카테고리</div>
                        <div className="sub_content margin_b-20">{getCate2Name()}</div>
                        <div className="sub_title">2. 예산</div>
                        <div className="sub_content margin_b-20">{getPrice()}</div>
                        {/* <div className="sub_title">3. 브랜드</div>
                        <div className="sub_content margin_b-20">{getBrandName()}</div> */}
                        <div className="sub_title ">3. 상품</div>
                        {
                            prodNum>0?
                            <div>
                                <div className="sub_content margin_b-10">{getPrductNum()}</div>
                                {
                                    esApplyProdList.map((item) => {
                                        return (
                                            <ProdBlock key={item.prdct_id+""+item.opt_id}className="clearfix">
                                                <div className="clearfix margin_b-20">
                                                    <div className="container-left" onClick={()=>handlePdClick(item.prdct_id)} style={{cursor:'pointer'}}>
                                                            <ProdThumBlock backgroundimage={item.img.replace(/ /g, "%20")} />
                                                    </div>
                                                    <div className="container-right">
                                                        <div className="clearfix" style={{height:'30px'}}>
                                                            <div className="f-left prod-name" onClick={()=>handlePdClick(item.prdct_id)} style={{cursor:'pointer'}}>
                                                                            {item.prdct_nm}
                                                            </div>
                                                            <div className="f-right delete"onClick={()=>handleDeletePd(item)} style={{cursor:'pointer'}}/>
                                                        </div>
                                                        <div >
                                                            <div className="prod-opt" onClick={()=>handlePdClick(item.prdct_id)} style={{cursor:'pointer'}}>
                                                            {item.opt_nm}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ProdBlock>
                                        )
                                    }
                                    )
                                }
                            </div>
                            :
                            <div style={{height:'20px'}}>&nbsp;</div>
                        }
                        <div style={{height:'1px'}} ref={refRightBottom}></div>
                        </div>
                        {
                            prodNum>0?
                            <div>
                                <div className="line_dot margin_b-20" />
                                <div>
                                    <div className="total">총계</div>
                                    <div className="total_price "> {totalPrice&&Number(totalPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></div>
                                    <div style={{height:'20px'}}>&nbsp;</div>
                                </div>
                                
                            </div>
                            :
                            ''
                        }
                        
                        <div className="line" />
                        <div className="bottom">
                            {
                                prodNum<MIN_CNT?
                                <button className="next margin_b-10" ><span className="num1">{prodNum}</span>개 확인하기<span className="limit"> ({MIN_CNT}개 이상)</span></button>
                                :
                                <button className="next margin_b-10" onClick={handleNext}>선택한 <span className="num">{prodNum}</span>개 상품 목록보기</button>
                            }
                            
                            <button className="pre" onClick={handlePre}>이전</button>
                        </div>
                    </div>
                </EstimateStepContentsPCBlock>

                
                
                <EstimateStepBlankBlock ref={refBottom} height={esMyBudget&&esMyBudget>0&&totalPrice>0? "130px":"103px"}>&nbsp;</EstimateStepBlankBlock>
                
            <EstimatePopBgContainer style={{display:popup? "block":'none'}}/>
            <EstimatePopContainer>
                <MyEsPopupStep4 active={popup} handleClosePopup={handleClosePopup} pCateId={selCateId} pIndex={pIndex} handleReceiveFromPopup={handleReceiveFromPopup}/>
            </EstimatePopContainer>
            <EstimatePopBgContainer style={{display:popupPd? "block":'none'}}/>
            <EstimatePopContainer>
                <MyEsPopupPDStep4 active={popupPd} handleClosePopup={handleClosePopupPd} id={pdId}/>
            </EstimatePopContainer>
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}
            </Modal>
            <Footer siteMovePosition={isMobileOnly?'80px':'50px'} />
        </EstimateStepBlock>
    );
};

export default EstimateStep4;
